var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShapeEnv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 343.297,
    height: 282.483,
    viewBox: "0 0 343.297 282.483",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shape-env",
    transform: "translate(-486.703 -208.847)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1900",
    "data-name": "Ellipse 1900",
    cx: 118.414,
    cy: 118.413,
    rx: 118.414,
    ry: 118.413,
    transform: "translate(486.703 208.847)",
    fill: "rgba(255,208,138,0.56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M199.063,21.921c23.641,23.717,21.225,61.28,19.223,94.708-1.761,29.4-10.825,57.015-29.669,79.651-20.1,24.151-45.37,48.763-76.789,48.236-30.643-.514-52.375-27.573-72.439-50.74-17.3-19.98-27.124-43.367-31.621-69.412C2.3,92.67-8.233,57.1,11.39,31.616,31.8,5.116,69.473,2.574,102.874.849,136.951-.912,174.973-2.245,199.063,21.921Z",
    transform: "translate(537 428.042) rotate(-75)",
    fill: "#00e1f0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeEnv);
export default __webpack_public_path__ + "static/media/shape-env.a71f914099dac8c2e025ff46d7616fa8.svg";
export { ForwardRef as ReactComponent };